import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IOperationType } from "../api/operations/types.ts";

export enum EFiltersAliasState {
  Outflows = "outflows",
  Inflows = "inflows",
}

export interface IOperationListFiltersState {
  filterAlias: EFiltersAliasState;
  filterCodes: IOperationType[];
  setFilter: (state: EFiltersAliasState) => void;
  reset: () => void;
}

const initialState = {
  filterAlias: EFiltersAliasState.Outflows,
  filterCodes: ["TRANCHE" as IOperationType],
};

export const useOperationListFiltersStore = create<IOperationListFiltersState>()(
  devtools(set => ({
    ...initialState,
    setFilter: (newFilter) => {
      set({
        filterAlias: newFilter,
        filterCodes: newFilter === EFiltersAliasState.Outflows ? ["TRANCHE"] : ["RETURN", "REPAYMENT"],
      }, false, "operation-list-filters-store/setFilter");
    },
    reset: () => {
      set(initialState, false, "operation-list-filters-store/reset");
    },
  }),
  { name: "operation-list-filters-store" }),
);
